import { useState } from 'react'
import { Filter } from './types'
import { useFilters } from './hooks/use-filters'
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover'
import { Text } from '$components'
import { Options } from './options/options'

export function FilterItem({ filter }: { filter: Filter }) {
  const [isOpen, setOpen] = useState(false)
  const { getFilter } = useFilters()

  return (
    <Popover
      open={isOpen}
      onOpenChange={setOpen}
    >
      <PopoverTrigger asChild>
        <button className="w-full px-stack py-stack-tight focus:outline-none hover:bg-bg-subtle/50 flex items-center gap-stack-tight cursor-pointer">
          {filter.icon && (
            <div className="flex-shrink-0">
              <filter.icon className="size-4 text-fg-subtle" />
            </div>
          )}

          <Text type="s">
            {filter.label}
          </Text>

          {getFilter(filter) && (
            <div className="size-2 ml-auto rounded-pill bg-brand-hover" />
          )}
        </button>
      </PopoverTrigger>

      <PopoverContent
        side="right"
        align="start"
        sideOffset={2}
        collisionPadding={16}
        className="text-body-sm w-full min-w-[12rem] py-stack-tight border border-border z-50 rounded-surface bg-surface shadow-popover"
      >
        <Options filters={[filter]} />
      </PopoverContent>
    </Popover>
  )
}
